import React, { Fragment } from 'react';
import { translate } from '../../Services/translation';
const sameCategory = (item, index, array) =>
    (index > 0 && array[index - 1].category === array[index].category) ||
    item.showAll;

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => (
    <div className="quick-search-result">
        <ul className="quick-search-result__list">
            {result &&
                result.map((item, index, array) => (
                    <Fragment key={`${item.name}-${index}`}>
                        {item.category === 'NoHit' ||
                            sameCategory(item, index, array) ? null : (
                            <li className="quick-search-result__item quick-search-result__group-header">
                                {item.category}
                            </li>
                        )}
                        <li
                            className={`quick-search-result__item ${selectedItem === index
                                ? 'quick-search-result__item--selected'
                                : ''
                                }`}
                        >
                            {!item.showAll &&
                                <a
                                    className={
                                        item.showAll
                                            ? 'quick-search-result__show-all'
                                            : `quick-search-result__link ${item.url ? '' : 'quick-search-result__link--disabled'
                                            } row`
                                    }
                                    href={item.category !== 'NoHit' ? item.url : ''}
                                >
                                    {item.category === 'Produkter' &&
                                        <figure className="quick-search-result__figure">
                                            {item.hasImage && item.imageSource && (
                                                <img
                                                    className="quick-search-result__image"
                                                    src={item.imageSource}
                                                />
                                            )}
                                        </figure>
                                    }
                                    <span>{item.name}</span>
                                </a>
                            }
                        </li>
                    </Fragment>
                ))}
        </ul>
        <a href={searchUrl} className="button expanded quick-search-result__show-all-button"> {translate('quicksearchresult.showall')}</a>
    </div>
);

export default QuickSearchResult;


